import React, { useState, useEffect,useRef } from 'react';
import {
    Card,
    Input,
    Button,
    Typography
} from "@material-tailwind/react";
import {
    IdentificationIcon,
    LockClosedIcon
} from "@heroicons/react/24/solid";
import Logo from '../componentes/Logo';
import Swal from 'sweetalert2';
import Axios from 'axios';
import { useParams } from 'react-router-dom';
import TurnstileWidget from '../componentes/TurnstileWidget';

export default function Login({ login, mostrarError, error,isIOSWebView }) {
    // 2. Quitamos password del estado para usar la Ref y ocultar el valor en el inspect
    const [datosLogin, setdatosLogin] = useState({ nro_documento: '' });
    const [captchaToken, setCaptchaToken] = useState(null);
    const [res, setRes] = useState(null);
    const passwordRef = useRef(null);
    const [keyTurnstile,setKeyTurnstile] = useState(0)

    const parametros = useParams();

       
    /* =========================
       INPUTS
    ========================== */
    const handleInputChange = (e) => {
        const regex = /^[0-9\b]+$/;

        if (e.target.value === '' || regex.test(e.target.value)) {
            setdatosLogin({ ...datosLogin, [e.target.name]: e.target.value });
        }
    };

    /* =========================
       LOGIN NORMAL
    ========================== */
    async function handleSubmit(e) {
        e.preventDefault();

        if (!captchaToken && !isIOSWebView) {
            Swal.fire({ icon: 'warning', text: 'Por favor complete la validación de seguridad.' });
            return;
        }

        try {
            await login(
                datosLogin.nro_documento,
                //datosLogin.cod_seguridad,
                passwordRef.current.value,
                captchaToken
            );
            setCaptchaToken(null); // token efímero
        } catch (err) {
            setCaptchaToken(null);
            setKeyTurnstile(keyTurnstile + 1)
        }
    }

    /* =========================
       AUTOLOGIN POR TRÁMITE
    ========================== */
    useEffect(() => {
        if (parametros.id_tramite && !error && captchaToken) {
            buscarLoginTramite(parametros.id_tramite, captchaToken);
        }
    }, [captchaToken]);

    const buscarLoginTramite = async (id_tramite, token) => {
        try {
            const { data } = await Axios.get(`/api/tablasgenerales/inicio/autologin/${id_tramite}`);
            if (data.length > 0) {
                await login(
                    data[0]?.nro_documento?.toString() || '',
                    data[0]?.cod_seguridad?.toString() || '',
                    token
                );
                setCaptchaToken(null);
            } else {
                mostrarError('No se han podido identificar los datos de login.');
                setRes(true);
            }
        } catch (err) {
            mostrarError(err);
            setRes(true);
        }
    };

    /* =========================
       RECUPERAR CÓDIGO
    ========================== */
    const recuperarCodSeguridad = async (documento) => {
        if (!documento || !captchaToken) {
            Swal.fire({ icon: 'warning', text: 'Debe completar la validación de seguridad.' });
            return;
        }

        try {
            const resultado = await Axios.post(`/api/usuarios/recuperarid/`, {
                documento: documento.trim(),
                captchaToken
            });
            setCaptchaToken(null);
            return resultado;
        } catch (err) {
            throw err.response?.data?.message || 'Error';
        }
    };

    const pedirCodSeguridad = async () => {
        const { value: documento, isConfirmed } = await Swal.fire({
            html: '<p>Para recuperar su código ingrese su documento</p>',
            input: 'text',
            showCancelButton: true
        });

        if (isConfirmed && documento) {
            try {
                const resultado = await recuperarCodSeguridad(documento);
                Swal.fire({ icon: 'success', html: resultado.data.message });
            } catch (err) {
                Swal.fire({ icon: 'error', text: err });
            }
        }
    };

    /* =========================
       ERRORES EN AUTOLOGIN
    ========================== */
    if (error && parametros.id_tramite) {
        return (
            <Card className="FormContainer p-8 text-center">
                <Logo />
                <Typography variant="h6">{error}</Typography>
                <Ayuda />
            </Card>
        );
    }

    /* =========================
       SOLO CAPTCHA (AUTOLOGIN)
    ========================== */
    if (parametros.id_tramite) {
        return (
            <Card className="FormContainer p-8 text-center">
                <Logo />

                {!captchaToken ? (
                    <>
                        <Typography variant="h5">Verificación de Seguridad</Typography>

                        <TurnstileWidget
                            siteKey={process.env.REACT_APP_CLOUDFLARE_PUBLIC_KEY}
                            action="autologin"
                            onToken={setCaptchaToken}
                        />
                    </>
                ) : (
                    <Typography color="blue">Validando identidad…</Typography>
                )}
            </Card>
        );
    }

    /* =========================
       LOGIN NORMAL
    ========================== */
    return (
        <div className="Signup">
            <Card className="FormContainer login">
                <Logo />
                <p className="text-center text-xl">Login</p>

                <form onSubmit={handleSubmit}>
                    <div className="flex flex-col items-center w-full">
                        <Typography 
                            className="text-left w-full font-medium"
                            variant="small"
                            color="blue-gray"
                        >DNI</Typography>
                        <Input
                        name="nro_documento"
                        value={datosLogin.nro_documento}
                        onChange={handleInputChange}
                        className="w-full"
                        />

                        <Typography 
                            variant="small"
                            color="blue-gray"
                            className="mt-3 text-left w-full font-medium">Código de seguridad</Typography>

                        {/* <Input
                        type="password"
                        name="cod_seguridad"
                        value={datosLogin.cod_seguridad}
                        onChange={handleInputChange}
                        className="w-full"
                        /> */}
                        <Input
                        type="password"
                        name="cod_seguridad"
                        inputRef={passwordRef}   // Material Tailwind usa inputRef
                        className="w-full"
                        autoComplete="current-password"
                        />
                        <Button
                        type="submit"
                        className="w-full mt-4"
                        >
                        Ingresar
                        </Button>
                    </div>
                </form>

                {/* CAPTCHA FUERA DEL FORM */}
                {!isIOSWebView && <div className='mt-5'>
                    <TurnstileWidget
                        key={keyTurnstile} // Para forzar que se re-renderice cuando hay un error
                        siteKey={process.env.REACT_APP_CLOUDFLARE_PUBLIC_KEY}
                        action="login"
                        onToken={setCaptchaToken}
                    />
                </div>}

                {error && (
                    <Typography color="red" className="text-center mt-2">
                        {error}
                    </Typography>
                )}

                <a onClick={pedirCodSeguridad} className="cursor-pointer text-blue-500 mt-3 block text-center">
                    Olvidé mi código de seguridad
                </a>

                <Ayuda />
            </Card>
        </div>
    );
}

const Ayuda = () => (
    <div className="text-center mt-6 text-sm">
        <Typography>Ante la duda comuníquese con nosotros</Typography>
        <a href="http://uad.org.ar" target="_blank" rel="noreferrer">www.uad.org.ar</a>
    </div>
);
